
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "notification",
    },
    title: {
      type: String,
      default: "Lorem ipsum",
    },
  },
  emits: ["close"],
  data: () => ({
    icon: "",
    color: "blue",
    dialogVisible: false,
  }),
  mounted() {
    if (this.type == "alert" || this.type == "error") {
      this.color = "red";
    }
  },
  methods: {
    onShow() {
      var buttons = (
        this.$refs as HTMLFormElement
      ).slotButtonContainer.querySelectorAll(".p-button");
      if (buttons.length) {
        [...buttons].forEach((button) => {
          button.classList.add("p-button-lg");
          if (this.color == "red") {
            button.classList.add("p-button-danger");
          }
        });
      }
    },
    close() {
      this.$emit("close");
    },
  },
});
